export default {
  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/signatures/")
        .then((response) => {
          context.commit("setPlans", response.data.results);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  change_current_signature(context, current_signature) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/change-signature", { current_signature })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
